import { type } from "arktype";
import { Unit } from "./vocabulary";

// R-DOM-06: stored as entered plus normalized, with an `ambiguous` marker.
export const LoadNotation = type({
  enteredText: "string",
  "normalizedKg?": "number | null",
  "unit?": Unit,
  ambiguous: "boolean",
  "assumption?": "string | null",
  "resolution?": "'per_hand' | 'total' | null",
});
export type LoadNotation = typeof LoadNotation.infer;
